/** Installer jobs DNO filter chips — keep in sync with backend EnaApplicationStatus + ProjectDnoStatus. */

export type DnoJobFilter = "all" | "needs_you" | "with_dno" | "approved";

const NEEDS_YOU = new Set([
  "not_started",
  "draft",
  "ready_to_send",
  "send_failed",
  "further_information_required",
  "dno_works_required",
  "commissioning_update_required",
  "failed_invalid_cut_out_image",
  "image_scan_failed",
]);

const WITH_DNO = new Set([
  "submitted",
  "unknown",
  "awaiting_assessment",
  "scanning_cut_out_image",
  "under_assessment",
  "escalated_to_dno",
  "re_escalated_to_dno",
]);

const APPROVED = new Set([
  "auto_approved",
  "dno_approved",
  "dno_approved_with_limit",
  "re_auto_approved",
  "ex_mpan_provided",
  "commissioning_submitted",
  "commissioning_accepted",
]);

export function dnoStatusKey(status?: string | null): string {
  return status && status.length > 0 ? status : "not_started";
}

export function projectMatchesDnoFilter(
  dnoStatus: string | undefined | null,
  filter: DnoJobFilter,
): boolean {
  if (filter === "all") return true;
  const key = dnoStatusKey(dnoStatus);
  if (filter === "needs_you") return NEEDS_YOU.has(key);
  if (filter === "with_dno") return WITH_DNO.has(key);
  if (filter === "approved") return APPROVED.has(key);
  return true;
}

export function dnoBadgeClass(status?: string | null): string {
  const key = dnoStatusKey(status);
  if (APPROVED.has(key)) return "bg-brand-lime/20 text-brand-lime";
  if (NEEDS_YOU.has(key)) return "bg-orange-500/20 text-orange-400";
  if (WITH_DNO.has(key)) return "bg-[#3d8eff]/20 text-[#3d8eff]";
  if (key === "failed" || key === "failed_too_large" || key === "send_failed") {
    return "bg-red-500/20 text-red-400";
  }
  if (key === "handed_off") return "bg-white/10 text-white/60";
  return "bg-purple-500/20 text-purple-400";
}
